import PropTypes from 'prop-types';

const AllowGifEmoji = ({ allowed, children }) => (allowed ? children : '');

AllowGifEmoji.propTypes = {
  allowed: PropTypes.bool.isRequired,
};

export default AllowGifEmoji;



// WEBPACK FOOTER //
// ./src/components/modules/allowGifEmoji/AllowGifEmoji.js